import { Suspense, lazy } from 'react';
import { OverlayedLoader } from '@mews-commander/ui';

const SettingsContainer = lazy(
    async () => import(/* webpackChunkName: "integrationClientSettings" */ './SettingsContainer')
);

export const LazySettings = (props: React.ComponentProps<typeof SettingsContainer>) => (
    <Suspense fallback={<OverlayedLoader fixed show />}>
        <SettingsContainer {...props} />
    </Suspense>
);
